import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop-Komponente
 * Scrollt automatisch nach oben, wenn sich die Route ändert
 */
const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Smooth scroll nach oben bei Route-Änderung
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
